import { render } from "./scope-own-function.vue?vue&type=template&id=182082c8"
import script from "./scope-own-function.vue?vue&type=script&lang=js"
export * from "./scope-own-function.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dereklei/Documents/DotnetProjects/WorkProjects/OAuth.Server.OneId/OAuth.Server/Web/Saas.Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__